import { pcbEditorBehaviors } from "@buildwithflux/constants";
export function enforceGridPrecisionInMeters(valueInMeters, gridPositionInMetersDecimals = pcbEditorBehaviors.gridPositionInMetersDecimals) {
    // TODO: had a one-off crash where toFixed(..) was undefined, but wasn't able to repro
    return Number(valueInMeters.toFixed(gridPositionInMetersDecimals));
}
export function enforceGridPrecisionInMm(valueInMm) {
    return Number(valueInMm.toFixed(pcbEditorBehaviors.gridPositionInMmDecimals));
}
export function enforceGridPrecisionInRad(valueInRad) {
    return Number(valueInRad.toFixed(pcbEditorBehaviors.gridPositionInRadDecimals));
}
export function enforceGridPrecisionInDeg(valueInDeg) {
    return Number(valueInDeg.toFixed(pcbEditorBehaviors.gridPositionInDegDecimals));
}
//# sourceMappingURL=enforceGridPrecision.js.map